export default class ApiError extends Error {
    _code;
    _response;
    constructor(message, code, response) {
        super(message);
        this._code = code;
        this._response = response;
    }
    get code() {
        return this._code;
    }
    get response() {
        return this._response;
    }
}
